

document.addEventListener("DOMContentLoaded", function() {
    let today = new Date();
    let cutt_off_date = new Date("12/22/2027");
    let msPerDay = 24 * 60 * 60 * 1000 ;
    let timeLeft = (cutt_off_date.getTime() - today.getTime());
    let e_daysLeft = timeLeft / msPerDay;
    let daysLeftUntilCutOff = Math.floor(e_daysLeft);
    let daysRule = daysLeftUntilCutOff < 0 ?  `.arrives_by_collection, .arrives_by_product{ display:none;}` : `.arrives_by_collection, .arrives_by_product{ display:block;}`;

    document.querySelector('#arrives_by_rules').innerHTML = daysRule;
    console.log('days till cut off: ' + daysLeftUntilCutOff)
});